export default __webpack_public_path__ + "static/media/warning-circle.e87cbf58.svg";